module.exports = __webpack_public_path__ + "img/EVAC-3C_NOMARK-front.c2a3a70e.jpg";